<a *ngIf="buttonType=='button' && !customTag && vars.social" mat-raised-button
    class="whatsapp-btn btn-whatsapp share-btn" [style.color]="color"
    (click)="getWhatsAppMessage()"
    [style.background-color]="backgroudColor">
  <mat-icon class="icon-whatsapp" [style.color]="color"></mat-icon>
  <span *ngIf="label" class="label">{{label}}</span>
  <span class="whatsapp-count" [style.color]="color" *ngIf="whatsAppCount>0">({{whatsAppCount | abbreviateNumber}})</span>
</a>

<a *ngIf="buttonType=='button' && customTag && vars.social" mat-raised-button
    class="whatsapp-btn btn-whatsapp share-btn" [style.color]="color"
    (click)="getWhatsAppMessage()"
    [style.background-color]="backgroudColor">
  <mat-icon class="icon-whatsapp icon-btn" [style.-webkit-text-fill-color]="color"></mat-icon> {{label}}
  <span class="whatsapp-count" [style.color]="color" *ngIf="whatsAppCount>0">({{whatsAppCount | abbreviateNumber}})</span>
</a>

<div *ngIf="buttonType=='round' && vars.social" class="whatsapp-container">
  <a class="whatsapp-float-btn btn-whatsapp share-btn" (click)="getWhatsAppMessage()" mat-icon-button>
    <mat-icon class="icon-whatsapp"></mat-icon>
  </a>
</div>

<div *ngIf="buttonType=='flat' && vars.social" class="whatsapp-share">
  <button class="whatsapp-flat-btn btn-whatsapp share-btn" (click)="getWhatsAppMessage()" mat-flat-button>
    <span *ngIf="label"></span>
    <i class="material-icons">whatsapp</i>
  </button>
</div>

<div *ngIf="buttonType=='flatround' && vars.social" class="whatsapp-share">
  <button class="whatsapp-flatround-btn btn-whatsapp share-btn" (click)="getWhatsAppMessage()" mat-flat-button>
    <mat-icon class="icon-whatsapp"></mat-icon>
  </button>
</div>